<template>
  <div class="public-content order">
    <div class="breadcrumb">业务信息</div>
    <div class="right-main">
      <!--      查询订单-->
      <el-form :inline="true" :model="salesmanVo" label-width="80px" class="demo-form-inline">
        <el-row>
          <el-col :span="6">
            <el-form-item label="业务:">
              <el-input v-model="salesmanVo.fullName" placeholder="请输入业务姓名" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="手机号:">
              <el-input v-model="salesmanVo.phone" placeholder="请输入手机号" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="申请日期:" class="el-date-width">
              <el-date-picker clearable v-model="value2" type="daterange" align="left" unlink-panels range-separator="至" start-placeholder="请选择开始日期" end-placeholder="请选择结束日期"
                :picker-options="pickerOptions">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="4" class="fn-right form-btn">
            <el-button class="search-ok" @click="getSalesList" round>查询</el-button>
          </el-col>
        </el-row>
      </el-form>
      <div class="data-list">
        <el-table :data="tableData" border style="width: 100%">
          <el-table-column prop="fullName" label="业务" min-width="10px">
          </el-table-column>
          <el-table-column prop="phone" label="手机号" min-width="10px">
          </el-table-column>
          <el-table-column prop="address.completeAddress" label="地址" min-width="10">
          </el-table-column>
          <el-table-column prop="registerTime" label="申请日期" min-width="10">
          </el-table-column>
          <el-table-column label="平台数量" min-width="10px">
            <template v-slot="scope">
              <span class="color-blue">{{ scope.row.storeNumber }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" min-width="10px">
            <template v-slot="scope">
              <span class="color-blue" @click="dialogVisible = true, editRelationVo.id = scope.row.id">确认选中</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--    分页-->
      <v-pagination :queryInfo="queryInfo" @changePage="changePage" class="v-pagination"></v-pagination>
    </div>
    <CombinedDialog ref="dialogRef"></CombinedDialog>
    <!-- 选中 -->
    <el-dialog :close-on-click-modal="false" title="确认提示" :visible.sync="dialogVisible" width="30%">
      <span>是否变更绑定此业务</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="change" v-preventReClick>确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import VPagination from '@/components/Pagination/index.vue'
import CombinedDialog from '@/components/Dialog/CombinedDialog/index.vue'
import { getSalesmanList, editRelation } from '@/api/crm'
export default {
  name: 'order',
  components: {
    VPagination,
    CombinedDialog
  },
  inject: ['reload'],
  data () {
    return {
      dialogVisible: false,
      salesmanVo: {
        fullName: '',
        phone: '',
        registerTimeBegin: '',
        registerTimeEnd: ''
      },
      editRelationVo: {
        id: '',
        status: '1',
        storeIds: [+this.$route.query.id]
      },
      tableData: [{
        salesman: '29828239888',
        phone: '',
        address: '',
        createDate: '',
        count: 2,
        operation: '确认选中'
      }],
      queryInfo: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      value2: '',
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      }
    }
  },
  watch: {
  },
  created () {
    this.getSalesList()
  },
  methods: {
    // 确认帮定
    change () {
      editRelation(this.editRelationVo).then(res => {
        if (res.data.success) {
          this.$message.success('绑定成功')
          this.$router.go(-1)
        }
      })
    },
    // 获取业务列表
    getSalesList () {
      getSalesmanList({ pageNum: this.queryInfo.pageNum, pageSize: this.queryInfo.pageSize, salesmanVo: this.salesmanVo }).then(res => {
        if (res.data.success) {
          this.tableData = res.data.data.records.map(a => {
            if (a.phone) {
              a.phone = this.$msg.filterBridal(a.phone)
            }
            return a
          })
          this.queryInfo.total = res.data.data.total
        }
      })
    },
    changePage (val) {
      this.queryInfo = val
      this.getSalesList()
    }
  }
}
</script>
<style scoped lang="less">
@import "index";
@deep: ~">>>";
</style>
